/**
 * Tishya: colour control for the Pair with / You may also like cards.
 *
 * Two independent behaviours:
 *
 *   1. Changing the colour on the MAIN product resets every card to that
 *      colour, so the strips stay "shown in <colour>, to match your <product>".
 *   2. Clicking a swatch on a CARD changes only that card. It does not touch
 *      the main product, the other cards, or the heading line, because the
 *      shopper is browsing that one item's colours.
 *
 * Each card carries a colourway -> {src, url} map rendered server side, so both
 * paths are a local swap with no refetch. Horizon does not re-render sibling
 * sections on a variant change, which is why the main colour is polled from the
 * picker rather than listened for on a section event.
 */
(() => {
  const mainColour = () => {
    const checked = document.querySelector('input[type="radio"][name^="Colour-"]:checked');
    return checked ? checked.value : null;
  };

  const mapFor = (card) => {
    try {
      return JSON.parse(card.dataset.tpairColours || '{}');
    } catch {
      return {};
    }
  };

  /** Point a single card at a colour. */
  const setCard = (card, colour) => {
    const entry = mapFor(card)[colour];
    if (!entry) return;

    const img = card.querySelector('[data-tpair-img]');
    if (img && entry.src && img.getAttribute('src') !== entry.src) {
      img.setAttribute('src', entry.src);
    }

    const link = card.querySelector('[data-tpair-link]');
    if (link && entry.url) link.setAttribute('href', entry.url);

    card.querySelectorAll('[data-tpair-swatch]').forEach((sw) => {
      const on = sw.dataset.tpairSwatch === colour;
      sw.classList.toggle('is-selected', on);
      sw.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  };

  /**
   * Follow the main product's colour.
   *
   * Cards marked data-tpair-static are excluded: You may also like shows that
   * product in its own default colour and stays there. Its swatches still work,
   * they are just driven only by clicks on the card itself.
   */
  const setAll = (colour) => {
    if (!colour) return;
    document
      .querySelectorAll('[data-tpair-card]:not([data-tpair-static])')
      .forEach((card) => setCard(card, colour));
    document.querySelectorAll('.tpair__colour').forEach((el) => {
      el.textContent = colour;
    });
  };

  // A card swatch is scoped to its own card only.
  document.addEventListener('click', (event) => {
    const swatch = event.target.closest('[data-tpair-swatch]');
    if (!swatch) return;

    event.preventDefault();
    const card = swatch.closest('[data-tpair-card]');
    if (card) setCard(card, swatch.dataset.tpairSwatch);
  });

  let last = mainColour();

  const check = () => {
    const now = mainColour();
    if (now !== last) {
      last = now;
      setAll(now);
    }
  };

  document.addEventListener('change', check);
  // The picker swaps markup on selection, so re-read shortly after a click too.
  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-tpair-swatch]')) return;
    setTimeout(check, 50);
  });
  window.addEventListener('popstate', () => setTimeout(check, 50));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setAll(mainColour()), { once: true });
  } else {
    setAll(mainColour());
  }
})();
